import NetworkDropdown from '@/components/shared/NetworkDropdown';
import TimeFrameSelector from '@/components/asset/TimeFrameSelector';
import { IoCloseOutline } from 'react-icons/io5';
import { useLocalStorage } from 'usehooks-ts';
import { useEffect, useState } from 'react';
import Image from 'next/image';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { useTouchHandlerName } from '@/hooks/utilities/use-mobile';
export default function NetworkTimeSelector({
  network,
  defaultNetwork,
  setNetwork,
  timeFrame,
  setTimeFrame
}) {
  const [showWildWest, setshowWildWest] = useLocalStorage('Wild West-categories', false);
  const [showMenu, setShowMenu] = useState(true);
  const [interactionEnabled, setInteractionEnabled] = useState(true);
  useEffect(() => {
    setShowMenu(true);
  }, [showWildWest]);

  // Monitor animation completion
  useEffect(() => {
    if (showMenu) {
      // Enable interaction after animation duration (500ms)
      const timeout = setTimeout(() => {
        setInteractionEnabled(true);
      }, 500);
      return () => clearTimeout(timeout);
    } else {
      // Disable interaction immediately when menu starts collapsing
      setInteractionEnabled(false);
    }
  }, [showMenu]);
  const disabledInteractionStyle: React.CSSProperties = {
    pointerEvents: interactionEnabled ? 'auto' : 'none',
    // Strictly typed
    opacity: interactionEnabled ? 1 : 0,
    transition: 'opacity 0.5s ease'
  };
  const touchHandlerName = useTouchHandlerName();
  return <div {...{
    [touchHandlerName]: () => {
      if (!showMenu) setShowMenu(true);
    }
  }} className={`${showMenu ? 'w-[280px]' : 'w-[40px]'} h-[40px] 
                flex ease-linear duration-500 rounded-full fixed bottom-[80px] left-0 right-0 m-auto bg-genius-pink z-[2001] items-center`} data-sentry-component="NetworkTimeSelector" data-sentry-source-file="NetworkTimeSelector.tsx">
      <div className='flex gap-1.5 w-full items-center justify-start overflow-x-scroll no-scrollbar'>
        <div className='pr-4 pl-[12px] flex text-genius-cream items-center rounded-full w-full relative justify-center'>
          <Image src={network.length > 1 ? '/static/icons/dark-genius.png' : getNetworkLogo(network[0])} width={100} height={100} alt={`logo`} className='h-[16px] w-[16px] absolute left-[12px]' data-sentry-element="Image" data-sentry-source-file="NetworkTimeSelector.tsx" />
          <div className='flex w-3/5 items-center mr-2 ease-linear duration-500 ta-c justify-center' style={disabledInteractionStyle}>
            {interactionEnabled && <NetworkDropdown shortAll={true} setNetwork={setNetwork} network={network} defaultNetwork={defaultNetwork} textBlack={true} />}
          </div>
          <div className='w-2/5 flex justify-end items-center ease-linear duration-500' style={disabledInteractionStyle}>
            {interactionEnabled && <TimeFrameSelector timeFrame={timeFrame} setTimeFrame={setTimeFrame} textBlack={true} />}
          </div>

          <div {...{
          [touchHandlerName]: e => {
            e.stopPropagation();
            setShowMenu(false);
          }
        }} style={{
          opacity: showMenu ? 1 : 0,
          transition: 'opacity 1.5s ease'
        }} className='w-1/5 text-genius-blue flex justify-end items-center cursor-pointer ease-linear duration-500'>
            <IoCloseOutline data-sentry-element="IoCloseOutline" data-sentry-source-file="NetworkTimeSelector.tsx" />
          </div>
        </div>
      </div>
    </div>;
}